module.exports = __webpack_public_path__ + "static/media/Bridge_Engineering_Large_Screen_01.4d4a8aab.jpg";